import { customerTestInstance } from '../axios';

const activateCustomer = (customerId: any) => customerTestInstance.put(`/customer/${customerId}/activate`);

export default activateCustomer;
